import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changeItem, newItem } from "../features/items/itemsSlice";

export default function Form() {
  const [name, setName] = useState("");
  const [amount, setAmount] = useState();
  const [type, setType] = useState("");
  const [editMode, setEditMode] = useState(false);

  const dispatch = useDispatch();
  const { isLoding, isError } = useSelector((state) => state.item);
  const { editing } = useSelector((state) => state.item);

  useEffect(() => {
    const { id, name, amount, type } = editing;
    if (id) {
      setEditMode(true);
      setName(name);
      setType(type);
      setAmount(amount);
    } else {
      setEditMode(false);
      reset();
    }
  }, [editing]);

  const reset = () => {
    setAmount("");
    setName("");
    setType("");
  };

  const cencelEdit = () => {
    reset();
    setEditMode(false);
  };

  const handleAddTransaction = (e) => {
    e.preventDefault();
    dispatch(
      newItem({
        name,
        type,
        amount,
      })
    );
    reset();
  };
  const handleEdit = (e) => {
    e.preventDefault();
    const { id } = editing;
    dispatch(
      changeItem({
        id,
        data: {
          name,
          type,
          amount,
        },
      })
    );
    reset();
  };
  return (
    <div className="form">
      <h3>Add new transaction</h3>
      <form onSubmit={editMode ? handleEdit : handleAddTransaction}>
        <div className="form-group">
          <label>Name</label>
          <input
            type="text"
            name="transaction_name"
            placeholder="Enter you name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="form-group radio">
          <label>Type</label>
          <div className="radio_group">
            <input
              type="radio"
              value="income"
              name="transaction_type"
              onChange={(e) => setType("income")}
              checked={type === "income"}
            />
            <label>Income</label>
          </div>
          <div className="radio_group">
            <input
              type="radio"
              value="expense"
              name="transaction_type"
              placeholder="Expense"
              onChange={(e) => setType("expense")}
              checked={type === "expense"}
            />
            <label>Expense</label>
          </div>
        </div>

        <div className="form-group">
          <label>Amount</label>
          <input
            type="number"
            placeholder="Enter amount"
            name="transaction_amount"
            value={amount}
            required
            onChange={(e) => setAmount(Number(e.target.value))}
          />
        </div>

        <button
          className="button buttonAlt bg-green-600"
          disabled={isLoding}
          type="submit"
        >
          {editMode ? "Update Transaction" : " Add Transaction"}
        </button>
      </form>
      {editMode && (
        <button className="button cancel_edit" onClick={cencelEdit}>
          Cancel Edit
        </button>
      )}
    </div>
  );
}
